import {Pipe, PipeTransform} from "@angular/core";
import {CallSchemaType} from "../../model/callSchema/callSchemaType";

@Pipe({name: 'schemaType'})
export class SchemaType implements PipeTransform {
    transform(value: any) {
        return CallSchemaType[value];
    }
}
